import React, { useState, useEffect } from "react";

import { Link } from "@reach/router";

const RoundButton = ({ text }) => {
    return (
        <Link to={`/hall/${text}`}
            getProps={({ isCurrent }) => {
                return {
                  class: "inline-flex my-auto font-bold rounded-full text-white w-12 h-12 mx-1 text-center cursor-pointer shadow-lg text-gray-200 " +
                  (isCurrent ? "bg-red-500 hover:bg-opacity-90" : "bg-black bg-opacity-75 hover:bg-opacity-50")
                };
              }}
            >
            <div className="my-auto mx-auto">
                { text }
            </div>
        </Link>
    );
    
};

export default RoundButton;
